import useAppSelector from '@webclient/hooks/useAppSelector';

import {
  QueryFunction,
  QueryKey,
  useQuery,
  UseQueryOptions,
} from '@tanstack/react-query';

type Props<TData, TError> = {
  queryKey: QueryKey;
  queryFn: QueryFunction<TData, QueryKey>;
  options?: Omit<
    UseQueryOptions<TData, TError, unknown, QueryKey>,
    'queryKey' | 'queryFn'
  >;
};

export default function useQueryAfterAuthenticationLoaded<TData, TError>({
  queryKey,
  queryFn,
  options,
}: Props<TData, TError>) {
  const isUserAuthenticated = useAppSelector(
    (state) => state.auth.isUserAuthenticated,
  );
  const enabled = options?.enabled ?? true;

  return useQuery({
    queryKey,
    queryFn,
    ...(options as Omit<
      UseQueryOptions<TData, TError>,
      'queryKey' | 'queryFn'
    >),
    enabled: enabled && isUserAuthenticated,
    staleTime: Infinity,
  });
}
